function getStep4Module3State(state) {
  return {
    formValues: state.step4Module3.formValues
  };
}

function getPostingPreviewInfo(state) {
  return state.step4Module3;
}

function getPlanInfo(state) {
  return {
    selectedPlan: null,
    currentPlan: null
  };
}

export { getStep4Module3State, getPostingPreviewInfo, getPlanInfo };
